export default {
  questions: [
    {
      order: 1,
      title: '¿Fue de utilidad la información entregada por su ejecutivo?',
      type: "check",
      field: "isUtilInfo",
      answers: [
        {
          order: 1,
          value: true,
          title: 'Si',
        },
        {
          order: 2,
          value: false,
          title: 'No',
        },
      ],
    },
    {
      order: 2,
      title: '¿Cuán satisfecho está con su ejecutivo?',
      type: "rate",
      field: "isSatisfied",
      value: 0
    },
    {
      order: 3,
      title: '¿Consideras qué tu ejecutivo está disponible cuando lo necesitas?',
      type: "check",
      field: "isAvailable",
      answers: [
        {
          order: 1,
          value: true,
          title: 'Si',
        },
        {
          order: 2,
          value: false,
          title: 'No',
        },
      ],
    },
    {
      order: 4,
      title: '¿Crees que tu ejecutivo posee los conocimientos necesarios para la labor que realiza?',
      type: "check",
      field: "hasKnowledge",
      answers: [
        {
          order: 1,
          value: true,
          title: 'Si',
        },
        {
          order: 2,
          value: false,
          title: 'No',
        },
      ],
    },
    {
      order: 5,
      title: '¿Quieres dejar un comentario?',
      type: "check&textarea",
      field: "sendComment",
      answers: [
        {
          order: 1,
          value: true,
          title: 'Si',
        },
        {
          order: 2,
          value: false,
          title: 'No',
        },
      ],
    },
    // {
    //   order: 5,
    //   title: 'Quieres dejar un comentario',
    //   type: "textarea",
    //   value: ""
    // },
  ],
};
